import type { z } from 'zod';

import { indexSearchSchema, listParams } from '@nucleus-commerce/admin-kit/index-table';

import type { CollectionListParams } from '../api/collections-api';
import { COLLECTION_FILTER_FIELDS, COLLECTION_SORTS } from '../components/collection-filters';

/** URL search params of the collections list; mirrors GET /admin/v1/stores/{storeId}/collections. */
export const collectionListSearchSchema = indexSearchSchema(COLLECTION_FILTER_FIELDS, {
  sort: COLLECTION_SORTS,
});

export type CollectionListSearch = z.infer<typeof collectionListSearchSchema>;

/** The list request for a validated search; the page's `useSearchListState().params` match it. */
export function collectionListParams(search: CollectionListSearch): CollectionListParams {
  return listParams(search, COLLECTION_FILTER_FIELDS);
}
